// extracted by css-extract-rspack-plugin
export default {"add-deviations-overlay":"vzSi23","addDeviationsOverlay":"vzSi23","content":"TVk8hQ"};